import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import lockImage from "../../../Images/LoginImages/Mask group (1).png"; // Update the path to your image
import styles from "./ForgotPassword.module.css";
import { AiOutlineLock } from "react-icons/ai";
import useApiFetcher from "../../../hooks/useApiFetcher";

const ForgotPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordsMatch, setPasswordsMatch] = useState(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate()
  const { apiFetcher } = useApiFetcher();

  const handleNewPasswordChange = (e) => {
    setNewPassword(e.target.value);
    setPasswordsMatch(e.target.value === confirmPassword);
  };
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    setPasswordsMatch(e.target.value === newPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!passwordsMatch) return;

    try {
      const response = await apiFetcher('/auth/reset-password', "POST", { password: newPassword, token });

      if (response?.success) {
        navigate("/login");
      } else {
        console.error("Password reset failed:", response);
      }
    } catch (error) {
      console.error("Error resetting password:", error);
    }
  };



  return (
    <div className={styles.container}>
      {/* Left Section: Image */}
      <div className={styles.leftSection}>
        <img src={lockImage} alt="Secure Lock" className={styles.image} />
      </div>

      {/* Right Section: Forgot Password Form */}
      <div className={styles.rightSection}>
        <div className={styles.formWrapper}>
          <h2 className={styles.title}>Reset Password?</h2>
          <p className={styles.subtitle}>
            Enter your temporary password below, then set a new password to secure your account.
          </p>
          <form onSubmit={handleSubmit}>


            {/* Temporary Password Input */}
            {/* <div className={styles.inputGroup}>
              <AiOutlineLock className={styles.icon} />
              <input
                type="password"
                placeholder="Enter Temporary Password"
                value={tempPassword}
                onChange={handleTempPasswordChange}
                className={styles.input}
                required
              />
            </div> */}

            {/* New Password Input */}
            <div className={styles.inputGroup}>
              <AiOutlineLock className={styles.icon} />
              <input
                type="password"
                placeholder="Enter New Password"
                value={newPassword}
                onChange={handleNewPasswordChange}
                className={styles.input}
                required
              />
            </div>

            {/* Confirm Password Input */}
            <div className={styles.inputGroup}>
              <AiOutlineLock className={styles.icon} />
              <input
                type="password"
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={handleConfirmPasswordChange}
                className={styles.input}
                required
              />
            </div>

            <button type="submit" className={styles.button} disabled={!passwordsMatch}>
              Continue
            </button>

            {/* Error Message if Passwords Don't Match */}
            {!passwordsMatch && confirmPassword && (
              <p className={styles.errorText} style={{ color: "red", marginTop: '4px', fontSize: '12px' }}>Passwords do not match</p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
